import React, { useEffect, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
// import { IStructure } from "../../../store/Structure/type";
// import { IUser } from "../../../store/User/type";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  List,
  ListItemText,
  ListItemButton,
  TextField,
  Button,
  Dialog,
  Toolbar,
  Slide,
  IconButton,
  ThemeProvider,
  Box,
  ListItem,
  Collapse,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useStyles from "../../helpers/Style";
import customtheme from "../../helpers/theme";
import { TransitionProps } from "@mui/material/transitions";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import myTheme from "../../helpers/theme";

const Transition = React.forwardRef(function Transition(
  props,
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FullScreenModal = (props) => {
  const { select, children, setSelect,settings } = props;

  const classes = useStyles();

  return (
    <ThemeProvider theme={myTheme(settings)}>
      <Dialog
        fullScreen
        open={select}
        onClose={() => {
          setSelect(false);
        }}
        TransitionComponent={Transition}
      >
        <AppBar elevation={0} className={" shadow-sm border-bottom"}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}></Box>
            <IconButton
              edge="end"
              onClick={() => {
                setSelect(false);
              }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          {children}
        </main>
      </Dialog>
    </ThemeProvider>
  );
};
// export default FullScreenModal;
export default connect(mapStateToProps)(FullScreenModal);
